import { styled } from "@mui/material/styles";

const Spacing = styled("div")(() => ({
  display: "flex",
  flex: 1,
}));

export default Spacing;
